import React, { useEffect, useState } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  Table,
  Row,
  Col,
  Button,
  Input,
} from "reactstrap";
import { FaDownload, FaPaperPlane } from "react-icons/fa";
import PageLayout from "../PageLayout";
import {
  getAssignedRequestApi,
  getMyReviewsApi,
  updateRemarksApi,
} from "src/network/api";
import { toast } from "react-toastify";
import { useAppSelector } from "src/state/store/store";

const ManageReviewer = () => {
  const [papers, setPapers] = useState([]);
  const [remarks, setRemarks] = useState({});
  const id = useAppSelector((state) => state.auth.user.id);

  const fetchPapers = async () => {
    try {
      const response = await getMyReviewsApi();
      if (response.status === 200 && response.data.status === 200) {
        setPapers(response.data.data);
        console.log(response.data);
      } else {
        toast.error(response.data.message);
      }
    } catch (e) {
      toast.error(e.response?.data?.message ?? e.message);
    }
  };

  useEffect(() => {
    fetchPapers();
  }, []);

  return (
    <PageLayout>
      <div className="mt-5 mb-7 container-fluid">
        <Row className="justify-content-center">
          <Col lg="12">
            <Card className="shadow">
              <CardHeader className="bg-primary text-white text-center">
                <h3 className="mb-0 text-white">My Reviews</h3>
              </CardHeader>
              <CardBody>
                <Table className="align-items-center table-flush" responsive>
                  <thead className="thead-light">
                    <tr>
                      <th>Paper Title</th>
                      <th>Subject</th>
                      <th>Journal Name</th>
                      <th>Paper Description</th>
                      <th>Keywords</th>
                      <th>My Remarks</th>
                    </tr>
                  </thead>
                  <tbody>
                    {papers?.length > 0 ? (
                      papers.map((paper) => (
                        <tr key={paper.id}>
                          <td>{paper.paper_title}</td>
                          <td>{paper.subjects}</td>
                          <td>{paper.journal_name}</td>
                          <td>{paper.abstract}</td>
                          <td>{paper.keywords}</td>
                          <td>{paper.reviewer_remarks}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={7} className="text-center">
                          No data available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </PageLayout>
  );
};

export default ManageReviewer;
